import { render } from "./AccommodationCard.vue?vue&type=template&id=27da8fa6&scoped=true"
import script from "./AccommodationCard.vue?vue&type=script&lang=js"
export * from "./AccommodationCard.vue?vue&type=script&lang=js"

import "./AccommodationCard.vue?vue&type=style&index=0&id=27da8fa6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27da8fa6"]])

export default __exports__